export default {
  categorias: {
    value: null,
    required: false,
    state: null
  },
  nome: {
    value: null,
    required: true,
    state: null
  },
  paId: {
    value: null,
    required: false,
    state: null
  },
  preferencial: {
    value: false,
    required: false,
    state: null
  },
  atendentePrincipal: {
    value: null,
    required: false,
    state: null
  },
  atendenteSubstituto: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/nxSenhas/mesa/components/add/mesa-form.js